import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { CheckCircle2 } from 'lucide-react';

const EmailVerified = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-4">
      <Card className="w-full max-w-md animate-fade-in text-center">
        <CardHeader>
          <div className="w-16 h-16 bg-emerald-500/10 rounded-full flex items-center justify-center mx-auto mb-4">
            <CheckCircle2 className="h-8 w-8 text-emerald-500" />
          </div>
          <CardTitle className="text-2xl">Email Verified!</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <p className="text-muted-foreground">
            Your email has been successfully verified. You can now sign in to your account.
          </p>
          <Link to="/login">
            <Button className="w-full" data-testid="email-verified-login">
              Continue to Sign In
            </Button>
          </Link>
        </CardContent>
      </Card>
    </div>
  );
};

export default EmailVerified;
